import { loadScript } from '@vfde-sails/utils';
import { getCMSConfig } from '../util/cms';
import {
    CAPTCHA_RENDERED,
    CAPTCHA_VERIFIED,
    SCRIPT_MTCAPTCHA,
    SCRIPT_MTCAPTCHA2,
} from '../container/AvailabilityCheck/constants';

export const onVerified = (payload: any) => {
    const event = new CustomEvent(CAPTCHA_VERIFIED, { detail: payload?.verifiedToken || '' });

    document.dispatchEvent(event);
};

export const onRendered = () => {
    const event = new CustomEvent(CAPTCHA_RENDERED);

    document.dispatchEvent(event);
};

export const resetCaptcha = (): Promise<void> => {
    return new Promise((resolve, reject) => {
        if (!window.mtcaptcha) {
            reject(new Error('mtCaptcha not found'));
            return;
        }

        const eventHandler = () => {
            document.removeEventListener(CAPTCHA_RENDERED, eventHandler);
            document.removeEventListener(CAPTCHA_VERIFIED, eventHandler);
            resolve();
        };

        document.addEventListener(CAPTCHA_RENDERED, eventHandler);
        document.addEventListener(CAPTCHA_VERIFIED, eventHandler);

        window.mtcaptcha.resetUI();
    });
};

export const listenForCaptchaVerify = (): Promise<void> => {
    return new Promise((resolve, _) => {
        const eventHandler = () => {
            document.removeEventListener(CAPTCHA_VERIFIED, eventHandler);
            resolve();
        };

        document.addEventListener(CAPTCHA_VERIFIED, eventHandler);
    });
};

export const mountCaptcha = () => {
    loadScript(SCRIPT_MTCAPTCHA, document.head);
    loadScript(SCRIPT_MTCAPTCHA2, document.head);

    window.mtcaptchaConfig = {
        sitekey: 'MTPublic-s9jH2tStR',
        theme: 'highcontrast',
        action: 'api-call',
        challangeType: 'imageonly',
        autoFormValidate: false,
        'verified-callback': onVerified,
        'rendered-callback': onRendered,
        customStyle: {
            showCard: true,
            cardShadow: false,
            cardShadowColor: '#ffffff',
            cardBorder: '#eeeeee',
            inputTextColor: '#333333',
            msgTextColor: '#cccccc',
            invalidMsgTextColor: '#e60000',
            inputBorderColor: {
                byDefault: '#cccccc',
                hover: '#afafaf',
                active: '#333333',
            },
            buttonIconColor: {
                verify: '#afafaf',
                success: '#428600',
                fail: '#e60000',
                audio: '#333333',
                audiofocus: '#333333',
                focus: '#333333',
            },
        },
        lang: 'de',
        customLangText: {
            de: getCMSConfig()?.captcha,
        },
    };
};

export const getCaptchaToken = () => window.mtcaptcha?.getVerifiedToken() ?? '';
